function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "ramda", "react", "@braindate/util/lib/image"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("ramda"), require("react"), require("@braindate/util/lib/image"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ramda, global.react, global.image);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ramda, React, _image) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  React = _interopRequireWildcard(React);
  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
  function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
  var ResponsivePicture = function ResponsivePicture(_ref) {
    var picture = _ref.picture,
      alt = _ref.alt,
      layoutClass = _ref.layoutClass,
      className = _ref.className,
      displayWidth = _ref.displayWidth,
      handleLoad = _ref.handleLoad,
      handleError = _ref.handleError,
      provideFallback = _ref.provideFallback;
    /*
     |------------------------------------------------------------------------------
     | Effects
     |------------------------------------------------------------------------------
     */

    React.useEffect(function () {
      if (handleLoad) {
        var imgElt = imgRef.current;
        if (imgElt instanceof HTMLImageElement && imgElt.complete) {
          handleLoad();
        }
      }
    }, []);

    /*
     |----------------------------------------------------------------------------
     | Refs
     |----------------------------------------------------------------------------
     */

    var imgRef = /*#__PURE__*/React.createRef();

    /*
     |----------------------------------------------------------------------------
     | Elements
     |----------------------------------------------------------------------------
     */

    var fallbackApplied = false;
    var onError = function onError() {
      if (handleError) {
        handleError();
      }
      if (provideFallback && !fallbackApplied) {
        fallbackApplied = true;
        // $FlowIssue
        imgRef.current.onerror = null;
        // $FlowIssue
        imgRef.current.onload = null;
        // $FlowIssue
        imgRef.current.srcset = "";
        // $FlowIssue
        imgRef.current.src = (0, _image.getOriginalPicture)(picture);
      }
    };
    var props = {
      alt: alt,
      className: layoutClass,
      onLoad: handleLoad,
      onError: onError,
      ref: imgRef
    };
    if ((0, _image.isOriginalPictureVectorial)(picture) || !displayWidth) {
      return /*#__PURE__*/React.createElement("img", _extends({}, props, {
        src: (0, _image.getOriginalPicture)(picture)
      }));
    }

    // TODO: build source elements (handle webP format)
    var sourceElts = [];
    var _getPictureSrcSets = (0, _image.getPictureSrcSets)(picture, displayWidth),
      src = _getPictureSrcSets.src,
      srcSet = _getPictureSrcSets.srcSet;
    return /*#__PURE__*/React.createElement("picture", null, sourceElts, /*#__PURE__*/React.createElement("img", _extends({}, props, {
      src: src,
      srcSet: srcSet,
      style: {
        verticalAlign: "middle"
      }
    })));
  };
  var _default = (0, _ramda.compose)(React.memo)(ResponsivePicture);
  _exports.default = _default;
});